export default "__VITE_ASSET__e62155be__"